import { CardHeader, Typography } from '@mui/material';
import React from 'react';
import styles from './location-status-header.module.scss';

type LocationStatusData = {
  locationName: string;
  owners: string[];
  installationCode: string;
};

type Props = {
  locationStatusData: LocationStatusData;
};

export const LocationStatusHeader = ({ locationStatusData }: Props) => {
  const getOwnersName = () => {
    if (locationStatusData.owners.length > 0) {
      return 'Owners: ' + locationStatusData.owners.join('; ');
    }
    return '';
  };

  return (
    <CardHeader
      title={locationStatusData.locationName}
      titleTypographyProps={{ variant: 'h5' }}
      subheader={
        <Typography variant="subtitle2">
          {getOwnersName()}
          <br />
          Installation code:{' '}
          {locationStatusData.installationCode || (
            <div className={styles.loading}>Loading...</div>
          )}
        </Typography>
      }
    />
  );
};
